import { motion } from "framer-motion";
import { ArrowRight, Download } from "lucide-react";
import { HERO } from "../data/content";

export const Hero = ({ onBookVisit, onBrochure }) => {
  return (
    <section
      id="hero"
      data-testid="hero-section-container"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${HERO.background})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-[#142415]/80 via-[#1E4320]/55 to-[#142415]/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#142415]/70 via-transparent to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 w-full pt-24 pb-16">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-xs sm:text-sm uppercase tracking-[0.3em] font-semibold text-[#EAE0D5] mb-6"
        >
          Ghatiyabhana Village · Sonkatch · Madhya Pradesh
        </motion.p>

        <motion.h1
          data-testid="hero-main-headline"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[1.05] tracking-tight text-white max-w-4xl drop-shadow-xl"
        >
          Escape the City.
          <br />
          <span className="italic text-[#EAE0D5]">Build Your Dream Farmhouse.</span>
        </motion.h1>

        <motion.p
          data-testid="hero-sub-headline"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="mt-7 text-lg sm:text-xl text-white/90 max-w-2xl font-light leading-relaxed drop-shadow"
        >
          {HERO.subheadline}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <button
            data-testid="hero-book-site-visit-button"
            onClick={onBookVisit}
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#C15B3D] px-8 py-4 text-base font-semibold text-white shadow-xl shadow-[#C15B3D]/30 transition-all duration-300 hover:bg-[#A84C31] hover:-translate-y-0.5"
          >
            Book a Site Visit
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </button>
          <button
            data-testid="hero-download-brochure-button"
            onClick={onBrochure}
            className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/60 bg-white/5 backdrop-blur-sm px-8 py-4 text-base font-semibold text-white transition-all duration-300 hover:bg-white hover:text-[#2C5F2D]"
          >
            <Download className="h-5 w-5" />
            Download Brochure
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
          className="mt-16 flex flex-wrap gap-x-10 gap-y-4 text-white"
        >
          {[
            ["36", "Exclusive Plots"],
            ["4000-5500", "Sq. Ft. Plots"],
            ["100%", "Gated & Secure"],
          ].map(([num, label]) => (
            <div key={label}>
              <div className="font-serif text-3xl sm:text-4xl">{num}</div>
              <div className="text-xs uppercase tracking-widest text-white/70 mt-1">
                {label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
